class RecentlyView extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        recentlyFunction(this);
    }
}

customElements.define("recently-view", RecentlyView);

async function recentlyFunction(node) {
    const nameCookie = "recently_view";
    let recentlyCookie = getCookie(nameCookie);

    let jsonSetting = JSON.parse(node.querySelector("#recently-viewed-json").innerHTML);
    let jsonProduct = JSON.parse(node.querySelector("#js-product-json").innerHTML);
    let productHandle = jsonProduct.handle;
    let cookieValue = [];
    // check product now had in cookie, if add remove and return array no has product now
    if (recentlyCookie) {
        let b = recentlyCookie.split("=");
        let json = JSON.parse(b[b.length - 1]);
        if (json.includes(productHandle)) {
            let index = json.indexOf(productHandle);
            json.splice(index, 1);
        }
        cookieValue = json;
    }

    if (cookieValue.length > 0) {
        for (let i = 0; i < cookieValue.length; i++) {
            // check limit lenght cookie with setting
            if (cookieValue.length > jsonSetting.limit_item) {
                cookieValue.shift();
            }
        }
        node.querySelector("#recently-viewed").innerHTML = await buildListItem(cookieValue);
        
        node.classList.remove("hidden");
        node.querySelector(".loading") ? node.querySelector(".loading").classList.remove("loading") : null;
    }

    // update cookie
    cookieValue.push(productHandle); // add newest product

    let expiresString = setExpires(jsonSetting.day_expire);
    let valueString = JSON.stringify(cookieValue);
    document.cookie = nameCookie + "=" + valueString + ";" + expiresString + ";path=/";
}
